import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  lighten,
  Tooltip,
  IconButton,
  Collapse,
} from "@mui/material";
import React from "react"; 
import themeF from "../../../../config/themeUser";
import { useContext } from "react";
import AuthContext from "../../../../Context/Auth/AuthContext";
import { hacerIcono } from "../../../../config/const";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import SubCategoria from "./SubCategoria";
const Categoria = (props) => {
  const { usuario } = useContext(AuthContext);
  const theme = themeF(usuario);
  const {
    categoria,
    mobile,
    handleDrawerToggle,
    activeRoute,
    open,
    rows,
    openExpand,
    handleClick,
    subCategorias,
  } = props;

  return (
    <>
      <Tooltip title={categoria.sidInfo.name} placement="right-start">
        <ListItem
          disablePadding
          sx={{
            maxHeight: "2.25rem",
            backgroundColor: activeRoute(
              categoria.sidInfo.layout + categoria.sidInfo.path
            )
              ? lighten(theme.palette.secondary.main, 0.7)
              : "",
            transitionProperty: "backgroundColor",
            transitionDuration: "1s",
          }}
        >
          <ListItemButton
            onClick={() => {
              if (mobile) handleDrawerToggle();
              props.history.push(
                categoria.sidInfo.layout + categoria.sidInfo.path
              );
            }}
            sx={{
              minHeight: 40,
              justifyContent: open ? "initial" : "center",
              px: 0.5,
              py: 0,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1 : "auto",
                justifyContent: "center",
              }}
            >
              {hacerIcono(categoria.sidInfo.icon, "primary")}
            </ListItemIcon>
            <ListItemText
              primary={categoria.sidInfo.name}
              primaryTypographyProps={{
                color: "primary",
                fontWeight: "bold",
                fontSize: ".8rem",
              }}
              sx={{ opacity: open ? 1 : 0 }}
            />
          </ListItemButton>
          {subCategorias.length === 0 ? null : (
            <IconButton
              aria-label="Expandir"
              size="small"
              onClick={(e) => {
                handleClick(
                  categoria.sidInfo.name,
                  Boolean(openExpand[categoria.sidInfo.name])
                );
              }}
              color="secondary"
            >
              {Boolean(openExpand[categoria.sidInfo.name]) ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </IconButton>
          )}
        </ListItem>
      </Tooltip>
      <Collapse
        in={openExpand[categoria.sidInfo.name]}
        timeout="auto"
        unmountOnExit
      >
        {subCategorias.map((subCategoria) => (
          <SubCategoria
            subCategoria={subCategoria}
            categoria={categoria}
            mobile={mobile}
            handleDrawerToggle={handleDrawerToggle}
            activeRoute={activeRoute}
            open={open}
            rows={rows}
            openExpand={openExpand}
            handleClick={handleClick}
          />
        ))}
      </Collapse>
    </>
  );
};

export default withRouter(Categoria);
